import React from 'react';

const Help = ({ width = 19, height = 19, colour = 'rgba(0, 173, 238)' }) => {
    return (
        <svg fill="#fff" viewBox="0 0 48 48" height={height} width={width}>
            <g transform="matrix(2,0,0,2,0,0)">
                <path
                    stroke={colour}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1.5"
                    d="M21.75 18.75H11.25L5.25 23.25V18.75H2.25C1.85218 18.75 1.47064 18.592 1.18934 18.3107C0.908035 18.0294 0.75 17.6478 0.75 17.25V2.25C0.75 1.85218 0.908035 1.47064 1.18934 1.18934C1.47064 0.908035 1.85218 0.75 2.25 0.75H21.75C22.1478 0.75 22.5294 0.908035 22.8107 1.18934C23.092 1.47064 23.25 1.85218 23.25 2.25V17.25C23.25 17.6478 23.092 18.0294 22.8107 18.3107C22.5294 18.592 22.1478 18.75 21.75 18.75Z"
                ></path>
                <path
                    stroke={colour}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1.5"
                    d="M9 6.75004C9.00011 6.20007 9.15139 5.66071 9.43732 5.19091C9.72325 4.72111 10.1328 4.33895 10.6213 4.08619C11.1097 3.83344 11.6583 3.71982 12.2069 3.75776C12.7556 3.79569 13.2833 3.98372 13.7323 4.30129C14.1813 4.61886 14.5344 5.05375 14.7529 5.55843C14.9715 6.06311 15.0471 6.61816 14.9715 7.16291C14.8959 7.70766 14.6721 8.22116 14.3244 8.64727C13.9767 9.07338 13.5185 9.39572 13 9.57904C12.7074 9.68248 12.4541 9.87412 12.275 10.1275C12.0959 10.381 11.9998 10.6837 12 10.994V11.25"
                ></path>
                <path
                    stroke={colour}
                    strokeWidth="1.5"
                    d="M12 15C11.7929 15 11.625 14.8321 11.625 14.625C11.625 14.4179 11.7929 14.25 12 14.25"
                ></path>
                <path
                    stroke={colour}
                    strokeWidth="1.5"
                    d="M12 15C12.2071 15 12.375 14.8321 12.375 14.625C12.375 14.4179 12.2071 14.25 12 14.25"
                />
            </g>
        </svg>
    );
};

export default Help;
